import api from "@core/api/api";

// Invoice PDF Service
export const invoicePDFService = {
  // Generate PDF for an invoice
  generatePDF: async (invoiceId) => {
    try {
      const response = await api.post(`/invoices/${invoiceId}/generate-pdf`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Download PDF for an invoice
  downloadPDF: async (invoiceId, filename = null) => {
    try {
      const response = await api.get(`/invoices/${invoiceId}/download-pdf`, {
        responseType: "blob",
      });

      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      // Set filename
      const contentDisposition = response.headers["content-disposition"];
      let fileName = filename;
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
        if (fileNameMatch) {
          fileName = fileNameMatch[1];
        }
      }

      link.setAttribute("download", fileName || `invoice-${invoiceId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return { success: true, message: "PDF downloaded successfully" };
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Generate and download PDF in one step
  generateAndDownload: async (invoiceId, filename = null) => {
    // First generate the PDF
    await invoicePDFService.generatePDF(invoiceId);

    // Then download it
    return await invoicePDFService.downloadPDF(invoiceId, filename);
  },

  // Check if PDF exists for an invoice
  checkPDFExists: async (invoiceId) => {
    try {
      const response = await api.get(`/invoices/${invoiceId}`);
      return {
        exists: !!response.data.pdfPath,
        pdfPath: response.data.pdfPath,
        downloadUrl: response.data.pdfPath
          ? `/public${response.data.pdfPath}`
          : null,
      };
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};
